import mutations from "./mutation_types.js";

export default {
    [mutations.SET_CURRENCY_NAME_SELECT](state, currencyNameSelect) {
        state.countriesSelectPriceList = [];
        state.namesSelect = [];

        currencyNameSelect.forEach(element => {
            if (element.type == "standard") {
                state.countriesSelectPriceList.push(element);
            } else {
                state.namesSelect.push(element);
            }
        });
    },

    [mutations.SET_CLIENT_ID](state, clientId) {
        state.clientId = clientId;
    },

    [mutations.PUSH_TO_PRICE_LISTS](state, priceList) {
        state.priceLists.push({ ...priceList });
    },

    [mutations.REMOVE__FROM_PRICE_LISTS](state, priceList) {
        state.priceLists.splice(state.priceLists.indexOf(priceList), 1);
    },

    [mutations.SET_ID_NUMBERS_TYPES_SELECT](state, idNumbersTypes) {
        state.idNumberTypesSelect = [...idNumbersTypes];
    },

    [mutations.PUSH_ID_NUMBERS_TYPES_OPTION](state, option) {
        state.idNumberTypesSelect.push({ ...option });
    },

    [mutations.SET_CURRENT_SA_DEPARTMENT](state, department) {
        state.currentSaDepartment = { ...department };
    },

    [mutations.SET_SELECTED_SA_DEPARTMENT](state, department) {
        state.selectedSaDepartment = { ...department };
    },

    [mutations.SET_ERRORS](state, errors) {
        state.errors = { ...errors };
    },

    [mutations.SET_OLD](state, old) {
        state.old = { ...old };
    },

    [mutations.SET_VALUES](state, values) {
        state.values = { ...values };
    },

    [mutations.PUSH_TO_COUNTRIES_SELECT](state, countires) {
        state.countriesSelect = [...countires];
    },

    [mutations.PUSH_TO_COUNTRIES_PRICELIST_SELECT](state, countires) {
        state.countriesSelectPriceList = [...countires];
    }
};
